import React, { useRef } from 'react';
import {
  Form,
  Radio,
  DatePicker,
  Selector,
  Button,
  Icon,
  Upload,
  InputNumber,
  Input,
} from '@roo/roo';
import styled from 'styled-components';
import { requiredRule, getRuleLen } from '../../../../utils/rules';
import { FieldX } from './fieldx';
import { get } from 'lodash';
import { OrgKs, getCert } from '../../_utils/config';
import { getPopContainer } from '../../_utils';
import { useUpdateEffect } from 'ahooks';
import dayjs from 'dayjs';
import { useSimpleContext } from '../../_context';
import { UploadField } from '../../_components/UploadField';
import { getSafeDate } from '../../../../utils/utils';

const { Field } = Form;
const RadioGroup = Radio.Group;

const OrgDiv = styled.div`
  .org-type-form {
    margin-top: 24px;
    //display: flex;
    width: 75%;
    margin-left: 29%;
    label {
      text-align: left;
    }
  }
  .cert-list {
    width: calc(100% + 94px);
    background: #fafafa;
    border-radius: 8px;
    padding: 24px;
    margin-left: -111px;
    color: #000;
    label {
      text-align: left;
    }
  }
  .cert-table {
    display: grid;
    grid-template-columns: repeat(4, auto);
    border: 1px solid #eee;
    grid-gap: 1px;
    background-color: #eee;
    //height: 300px;
    div {
      background-color: #fff;
    }
    .c-title {
      background: #fafafa;
      text-align: center;
      height: 40px;
      display: inline-block;
      line-height: 40px;
    }
    .c-type {
      height: 40px;
      display: inline-block;
      line-height: 40px;
      text-align: center;
    }
    .c-persist,
    .c-date {
      height: 40px;
      div,
      input {
        height: 40px;
      }
    }
    .c-date {
      .addon-icon {
        display: inline-block !important;
        height: 38px;
        line-height: 38px;
      }
    }
    .p-disabled {
      .addon-icon {
        background-color: #fafafa;
      }
    }
    .c-file {
      height: 40px;
      button {
        height: 100%;
      }
      .files-view-list {
        padding: 0;
        border: none;
        text-align: center;
        position: relative;
        top: 10px;
      }
      text-align: center;
      .file-full {
        position: relative;
        top: 5px;
        display: inline-block;
        .roo-upload-container {
          padding: 0;
          border: none;
          text-align: center;
          .roo-upload-list-item {
            text-align: center;
            width: 100px;
            line-height: 16px;
            span {
              font-weight: 500;
              font-family: PingFangSC-Medium;
              font-size: 14px;
              color: #222222;
              line-height: 12px;
              max-width: 80px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              display: inline-block;
            }
          }
        }
      }
    }
  }
  .prefix-w {
    ::after {
      content: '万元';
      position: relative;
      right: 24px;
    }
  }
  .roo-radio-group {
    min-width: 734px;
    .roo-radio {
      margin-right: 16px !important;
    }
  }
  .org-type-form {
    min-width: 561px;
  }
  .cert-list {
    min-width: 734px;
  }
`;
function useValidateCerts() {
  const { state } = useSimpleContext((t) => [t.disabled, t.hasSubmit]);
  return function validateCerts(certs = []) {
    if (state.disabled || state.isViewType || state.hasSubmit) {
      return undefined;
    }
    for (let i = 0; i < certs.length; i++) {
      const { isLongEffective, invalidDate, fileUrl } = certs[i];
      if (isLongEffective === 0 && !invalidDate) {
        return '请选择到期时间';
      }
      if (!fileUrl) {
        return '请上传证书文件';
      }
    }
    return undefined;
  };
}

export const Organization = function (props) {
  const { values, setFieldValue, idx, validateFields } = props;

  //0-一般企业 1-政府机关 2-个体工商户 3-事业单位 4-社会团体 5-其他机构
  const [typ, setTyp] = React.useState(get(values, `organizationType`));
  const { isMerge } = values;
  const organizationType = typ;
  const orgType = typ;

  const { state } = useSimpleContext((t) => [t.disabled]);
  const validateCerts = useValidateCerts();

  useUpdateEffect(
    // 三证合一选择后重置证书信息
    function () {
      setFieldValue(`baseInfo.${idx}.qualificationCertificate`, getCert(isMerge));
    },
    [isMerge]
  );
  useUpdateEffect(
    // 事业单位和社会团体使用法人证书
    function () {
      if (organizationType === 3 || organizationType === 4) {
        setFieldValue(`baseInfo.${idx}.qualificationCertificate`, getCert(organizationType));
      } else {
        setFieldValue(`baseInfo.${idx}.qualificationCertificate`, getCert(isMerge));
      }
      setTimeout(() => {
        props.validateForm();
        const infos = props.values.baseInfo || [];
        infos.forEach((info, idx) => {
          Object.keys(info).forEach((k) => {
            props.setFieldError(`baseInfo.${idx}.${k}`, '');
          });
        });
      }, 0);
    },
    [organizationType]
  );

  return (
    <OrgDiv className={'form-patch'}>
      <Field
        required={true}
        label='机构名称'
        name={`baseInfo.${idx}.organizationName`}
        rule={getRuleLen(20, true)}
        disabled={state.disabled}
        as={
          <Input maxLength={20} placeholder={`请输入${idx === 0 ? '主' : '联合'}申报机构的全称`} />
        }
      />
      <Field required={true} label='机构类型' name={`baseInfo.${idx}.organizationType`}>
        {({ value, handleChange, disabled }) => {
          return (
            <RadioGroup
              disabled={disabled}
              value={value}
              onChange={(e) => {
                handleChange(e);
                setTyp(e);
              }}
            >
              <Radio value={0}>一般企业</Radio>
              <Radio value={1}>政府机关</Radio>
              <Radio value={2}>个体工商户</Radio>
              <Radio value={3}>事业单位</Radio>
              <Radio value={4}>社会团体</Radio>
              <Radio value={5}>其他机构</Radio>
            </RadioGroup>
          );
        }}
      </Field>
      <div className={'org-type-form'}>
        <FieldX
          className={'org-id'}
          label='统一社会信用代码'
          name={`baseInfo.${idx}.creditCode`}
          cols={{ label: { span: 4 }, field: { span: 8 } }}
          rule={{
            required: true,
            type: 'string',
            pattern: /^[\d\w^_]{18}$/,
            message: '请输入正确的统一社会信用代码',
          }}
          orgType={orgType}
          as={<Input maxLength={50} placeholder='请输入此机构的统一社会信用代码' />}
        />
        <FieldX
          required={true}
          className={'org-id'}
          label='企业资质证书'
          name={`baseInfo.${idx}.certification`}
          layout={'vertical'}
          orgType={orgType}
          rule={undefined}
        >
          <div>
            <div className='t-info'>
              <Icon name='info-circle-o'></Icon>
              营业执照，组织机构代码证，税务登记证(请上传证件扫描件或拍摄清晰的数码照)
            </div>
          </div>
        </FieldX>
      </div>
      <FieldX
        required={false}
        className={'org-id'}
        label='资质证书'
        name={`baseInfo.${idx}.qualificationCertificate`}
        as={<OrganizationCert {...props} orgType={orgType} />}
        orgType={orgType}
        rule={{
          validator: (rule, value, callback) => {
            callback(validateCerts(value));
          },
        }}
      />
      <FieldX
        label={'成立日期'}
        name={`baseInfo.${idx}.registerDate`}
        placeholder={'请选择'}
        orgType={orgType}
      >
        {({ value, handleChange, disabled }) => {
          return (
            <DatePicker
              clearable={true}
              disabled={disabled}
              format={'YYYY-MM-DD'}
              valueOfType={'string'}
              value={getSafeDate(value)}
              popupContainer={getPopContainer}
              onChange={handleChange}
            />
          );
        }}
      </FieldX>
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.location}`}
        orgType={orgType}
        as={<Input maxLength={100} placeholder={'请输入精确到街道的地址'} />}
      />
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.legalPerson}`}
        orgType={orgType}
        as={<Input maxLength={50} placeholder={'请输入法定代表人姓名'} />}
      />
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.registeredCapital}`}
        placeholder={'请输入注册资金(可输入小数点)，若无则填无'}
        orgType={orgType}
        rule={null}
      >
        {(props) => {
          return (
            <InputNumber
              style={{ width: '100%' }}
              value={props.value || undefined}
              disabled={state.disabled}
              max={9999999}
              min={0}
              className={'prefix-w'}
              precision={2}
              onChange={(v) => {
                props.handleChange(String(v));
              }}
            />
          );
        }}
      </FieldX>
    </OrgDiv>
  );
};

// 资质证书
const OrganizationCert = function (props) {
  const { orgType, value: certs, idx } = props;
  const validateCerts = useValidateCerts();

  return (
    <div className={'cert-list'} style={{marginLeft: "-123px"}}>
      <FieldX
        required={true}
        name={`baseInfo.${idx}.isMerge`}
        label='是否三证合一'
        layout={'horizontal'}
        rule={undefined}
        orgType={orgType}
        as={
          <RadioGroup>
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </RadioGroup>
        }
      />
      <div className={'cert-table'}>
        <div className={'c-title'}>证件类型</div>
        <div className={'c-title'}>是否长期有效</div>
        <div className={'c-title'}>到期日期</div>
        <div className={'c-title'}>上传附件</div>
        {certs.map((cert, certIdx) => {
          return <OrgCertItem cert={cert} {...props} certIdx={certIdx} />;
        })}
      </div>
    </div>
  );
};

function OrgCertItem(props) {
  const { cert, idx, setFieldValue, certIdx, setFiledError, values } = props;
  const { state } = useSimpleContext((t) => [t.disabled]);
  const validateCerts = useValidateCerts();

  /**
   企业资质证书信息
     {
       type: 0, //0-三证合一，1-营业执照 2-组织机构代码证 3-税务登记证 4-事业单位法人证书/社会团体法人登记证书
       isLongEffective: 0, //0-否 1-是
       invalidDate: "",
       fileUrl: "",
      }
   */
  const certName = ['三证合一', '营业执照', '组织机构代码证', '税务登记证'];
  const certName2 = ['0', '1', '2', '事业单位法人证书', '社会团体法人登记证书'];

  function getCertName(code) {
    return certName[code] || certName2[Number(props.values.organizationType)];
  }
  useUpdateEffect(
    function () {
      // 长期有效切换后重置日期
      if (cert.isLongEffective === 1) {
        setFieldValue(
          `baseInfo.${idx}.qualificationCertificate.${certIdx}.invalidDate`,
          '2099-12-30'
        );
      } else {
        setFieldValue(
          `baseInfo.${idx}.qualificationCertificate.${certIdx}.invalidDate`,
          dayjs().format('YYYY-MM-DD')
        );
      }
    },
    [cert.isLongEffective]
  );

  useUpdateEffect(
    function () {
      setFiledError(
        `baseInfo.${idx}.qualificationCertificate`,
        validateCerts(values.qualificationCertificate || [])
      );
    },
    [cert.invalidDate, cert.isLongEffective, cert.fileUrl]
  );

  return (
    <React.Fragment>
      <div className={'c-type'}>{getCertName(Number(cert.type))}</div>
      <div className={'c-persist'}>
        <Selector
          style={{ width: '100%', height: 40 }}
          disabled={state.disabled}
          onChange={(v) => {
            setFieldValue(`baseInfo.${idx}.qualificationCertificate.${certIdx}.isLongEffective`, v);
          }}
          value={cert.isLongEffective}
          options={[
            { value: 1, label: '是' },
            { value: 0, label: '否' },
          ]}
          filterable
          disablePortal
        />
      </div>
      <div
        className={'c-date ' + (state.disabled || cert.isLongEffective === 1 ? 'p-disabled' : '')}
      >
        <DatePicker
          value={getSafeDate(cert.invalidDate)}
          disabled={state.disabled || cert.isLongEffective === 1}
          className={state.disabled || cert.isLongEffective === 1 ? 'p-disabled' : ''}
          format={'YYYY-MM-DD'}
          valueOfType={'string'}
          popupContainer={getPopContainer}
          onChange={(v) => {
            setFieldValue(`baseInfo.${idx}.qualificationCertificate.${certIdx}.invalidDate`, v);
          }}
        />
      </div>
      <div className={'c-file'}>
        <UploadField
          type={'img'}
          disabled={state.disabled}
          value={[cert.fileUrl]}
          handleChange={(urls = []) => {
            setFieldValue(`baseInfo.${idx}.qualificationCertificate.${certIdx}.fileUrl`, urls[0]);
          }}
        >
          <Button icon='upload' type='dashed' loading={false}>
            上传文件
          </Button>
        </UploadField>
      </div>
    </React.Fragment>
  );
}
